import React from 'react'
import { Switch as AntdSwitch, Form } from 'antd'
import styled, { css } from 'styled-components'
import Flex from 'components/Flex'

const FlexWrapper = styled(Flex)`
  width: ${props => props.width};
`
export const FormItem = styled(Form.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px !important'};
`
const StyledSwitch = styled(AntdSwitch)`
  box-shadow: none !important;
`
const LabelWrapper = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-right: 6px;
  color: #4d566e;
  ${props =>
    props.isImportant &&
    css`
      font-size: 15px;
      font-weight: 500;
      color: #4d566e;
    `}
`

const Switch = ({
  label,
  name,
  onChange,
  valuePropName,
  width = '100%',
  isImportant = false,
  ...rest
}) => {
  return (
    <FormItem name={name} valuePropName={valuePropName} {...rest}>
      <FlexWrapper spaceBetween centerVertically width={width}>
        <LabelWrapper isImportant={isImportant}>{label}</LabelWrapper>
        <StyledSwitch onChange={onChange} {...rest} />
      </FlexWrapper>
    </FormItem>
  )
}

export default Switch
